import { render, staticRenderFns } from "./ProductMain.vue?vue&type=template&id=31cd61f2&"
import script from "./ProductMain.vue?vue&type=script&lang=js&"
export * from "./ProductMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports